<script setup lang="ts">
import { AppModal } from '@libs/ui';

import { ActivityDetailsModalType } from '../../models';
import TicketsSelectorDesktopLoader from '../loaders/TicketsSelectorDesktopLoader.vue';
import {
  useActivityDetailsModalsStore,
  useActivityDetailsStore,
} from '../../stores';

import TicketsSelectorDesktop from './TicketsSelectorDesktop.vue';

interface TicketsSelectorModalEmit {
  (event: 'close'): void;
  (event: 'select-tickets'): void;
}
const emit = defineEmits<TicketsSelectorModalEmit>();

const activityDetailsModalsStore = useActivityDetailsModalsStore();
const activityDetailsStore = useActivityDetailsStore();

function handleSelectTickets(): void {
  emit('select-tickets');
  handleClose();
}

function handleClose(): void {
  emit('close');
}
</script>

<template>
  <AppModal
    v-if="
      activityDetailsModalsStore.activityDetailsModalType ===
      ActivityDetailsModalType.TicketsSelection
    "
    @close="handleClose"
  >
    <TicketsSelectorDesktopLoader
      v-if="activityDetailsStore.isLoadingTickets"
      @close="handleClose"
    />

    <TicketsSelectorDesktop
      v-else
      @close="handleClose"
      @select-tickets="handleSelectTickets"
    />
  </AppModal>
</template>
